export default __webpack_public_path__ + "static/media/P5.55498d3b.png";